"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _ModalConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-concur_android.css") : void 0);
var _ModalConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-concur_default.css") : void 0);
var _ModalConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-concur_gateway.css") : void 0);
var _ModalConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-concur_ios.css") : void 0);
var _ModalSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_fiori_3_dark.css") : void 0);
var _ModalSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_fiori_3_hcb.css") : void 0);
var _ModalSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_fiori_3_hcw.css") : void 0);
var _ModalSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_fiori_3.css") : void 0);
var _ModalSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_horizon_dark.css") : void 0);
var _ModalSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_horizon_hcb.css") : void 0);
var _ModalSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_horizon_hcw.css") : void 0);
var _ModalSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal-sap_horizon.css") : void 0);
var _excluded = ["children", "className", "classNameMap", "isResizable"];
var styles = {
  concur_android: _ModalConcur_android.default,
  concur_default: _ModalConcur_default.default,
  concur_gateway: _ModalConcur_gateway.default,
  concur_ios: _ModalConcur_ios.default,
  sap_fiori_3_dark: _ModalSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _ModalSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _ModalSap_fiori_3_hcw.default,
  sap_fiori_3: _ModalSap_fiori_.default,
  sap_horizon_dark: _ModalSap_horizon_dark.default,
  sap_horizon_hcb: _ModalSap_horizon_hcb.default,
  sap_horizon_hcw: _ModalSap_horizon_hcw.default,
  sap_horizon: _ModalSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-modal';
var ModalBody = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    classNameMap = props.classNameMap,
    isResizable = props.isResizable,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var bodyClasses = classnames("".concat(CSS_BLOCK, "__body"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__body--resizable"), isResizable), className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: bodyClasses,
    "data-nui-widgets": "Modal.Body",
    ref: ref
  }), children);
});
ModalBody.displayName = 'Modal.Body';
ModalBody.propTypes = {
  /** Content of the modal body. */
  children: _propTypes.default.node,
  /** Custom classes to add to the body’s `<div>` tag. */
  className: _propTypes.default.string,
  /** @ignore */
  isResizable: _propTypes.default.bool
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(ModalBody);
exports.default = _default;